import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { setSuppressSecondaryContent } from 'containers/App/actions';

// [componentObjectRefs...]
const references = [];

class SuppressSecondaryContent extends PureComponent {
  addReference() {
    if (!references.includes(this)) {
      references.push(this);
      if (references.length === 1) {
        this.props.setSuppressSecondaryContent(true);
      }
    }
  }

  removeReference() {
    const index = references.indexOf(this);
    if (index !== -1) {
      references.splice(index, 1);
      if (references.length === 0) {
        this.props.setSuppressSecondaryContent(false);
      }
    }
  }

  componentDidMount() {
    this.addReference();
  }

  componentWillUnmount() {
    this.removeReference();
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = dispatch => ({
  setSuppressSecondaryContent: suppress =>
    dispatch(setSuppressSecondaryContent(suppress))
});

const withConnect = connect(null, mapDispatchToProps);

export default withConnect(SuppressSecondaryContent);
